import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import * as action from 'components/DashboardView/actionTypes';

import styles from './SchoolListView.scss';
// to import local scss fle
const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington D.C',
  WN: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};
const SchoolListView = (props) => {
  // console.log('preference: ', props.t40);
  const clickToAdd = () => {
    const payload = {
      student_profile_id: props.profileId,
      college_id: props.saSchool.get('id'),
      type_of_list: 'WISHLIST',
    };
    props.addToList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
  };


  const clickToRemoveFromWishList = () => {
    const payload = {
      student_profile_id: props.profileId,
      college_id_index: props.wishListId,
      type_of_list: 'WISHLIST',
    };
    props.removeFromList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
  };

  if (props.profile !== undefined) {
    // console.log('name: ', props.profile.get('fullname'));
  }

  const clickToRequest = () => {
    const { subscribed, onTrial } = props;
    const contactedCountMap = props.profile.get('contactedCount');
    let contactedCount;
    if (contactedCountMap) {
      contactedCount = contactedCountMap.toJS();
    }
    const counter = contactedCount.count; // eslint-disable-line
    // console.log('contactedCount: ', contactedCount);
    // const undefinedCase = props.profile.get('contactedCount');
    const difference = moment().diff(contactedCount.lastContacted, 'hours');
    // console.log('hola', counter, difference, contactedCountMap);
    const req = {
      from_profile_id: props.profileId,
      college_id: props.saSchool.get('id'),
      request_type: 'INTEREST',
      college_name: props.saSchool.get('college'),
      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
      city: props.saSchool.get('city'),
      division: props.saSchool.get('division'),
      sa_name: props.fullname,
      sa_state: states[props.state],
      sa_preference: props.position_pref,
      sa_school: props.school,
      sa_city: props.city,
      sa_image: props.sa_image,
      sa_email: props.sa_email,
      year_of_graduation: props.year_of_graduation,
      team_page_link: props.saSchool.get('football_team_page'),
      question_link: props.saSchool.get('football_questionaire_page'),
      sa_twitter: ((props.profile.get('sa_twitter') !== undefined) && (props.profile.get('sa_twitter') !== null)) ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
      sa_height: props.profile.get('height'),
      sa_weight: props.profile.get('weight'),
      sa_t40: props.t40,
      request_views: props.requestViewedCount,
    };
    let maxCount = 1;
    if (subscribed || onTrial) {
      maxCount = 10;
    }
    // if (subscribed) {
    if (counter < maxCount || contactedCountMap === undefined) {
      // console.log('In 1st');
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.saSchool.get('id'),
        type_of_list: 'CONTACTED',
      };
      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

      if (props.inWishList) {
        clickToRemoveFromWishList();
      }
        props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
      props.showSnackBar('Added to contacted list, will keep you informed.');
    } else if (counter >= maxCount && difference >= 23) {
      // console.log('In 2nd');
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.saSchool.get('id'),
        type_of_list: 'CONTACTED',
      };
      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

      if (props.inWishList) {
        clickToRemoveFromWishList();
      }
        props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
      props.showSnackBar('Added to contacted list, will keep you informed.');
    } else {
      // console.log('subscribed');
      props.showCounterScreen();
    }
    // }
    // if (onTrial) {
    //   console.log('Ok here in trial if');
    //   if (counter < 10 || contactedCountMap === undefined) {
    //     console.log('In 1st');
    //     const payload = {
    //       student_profile_id: props.profileId,
    //       college_id: props.saSchool.get('id'),
    //       type_of_list: 'CONTACTED',
    //     };
    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

    //     if (props.inWishList) {
    //       clickToRemoveFromWishList();
    //     }
    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //     props.showSnackBar('Added to contacted list, will keep you informed.');
    //   } else if (counter >= 10 && difference >= 4) {
    //     console.log('In 2nd');
    //     const payload = {
    //       student_profile_id: props.profileId,
    //       college_id: props.saSchool.get('id'),
    //       type_of_list: 'CONTACTED',
    //     };
    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
    //     if (props.inWishList) {
    //       clickToRemoveFromWishList();
    //     }
    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //     props.showSnackBar('Added to contacted list, will keep you informed.');
    //   } else {
    //     console.log('trial');
    //     props.showCounterScreen();
    //   }
    // }
    // if (!subscribed && (counter < 1 || contactedCountMap === undefined)) {
    //   // eslint-disable-next-line no-debugger
    //   // debugger;
    //   const payload = {
    //     student_profile_id: props.profileId,
    //     college_id: props.saSchool.get('id'),
    //     type_of_list: 'CONTACTED',
    //   };
    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

    //   if (props.inWishList) {
    //     clickToRemoveFromWishList();
    //   }
    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //   props.showSnackBar('Added to contacted list, will keep you informed.');
    // } else if (!subscribed && (counter >= 1 && difference >= 5)) {
    //   // eslint-disable-next-line no-debugger
    //   // debugger;
    //   const payload = {
    //     student_profile_id: props.profileId,
    //     college_id: props.saSchool.get('id'),
    //     type_of_list: 'CONTACTED',
    //   };
    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
    //   if (props.inWishList) {
    //     clickToRemoveFromWishList();
    //   }
    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //   props.showSnackBar('Added to contacted list, will keep you informed.');
    // } else if (!subscribed && !onTrial) {
    //   console.log('free');
    //   props.showCounterScreen();
    // }
  };

  const renderIfIgnored = renderIf(props.ignoreListId === -1);

  const showDefaultStatus = props.fillQ || props.inviteToCamp;
  const renderDefaultStatus = renderIf(!showDefaultStatus);

  const renderFillQ = renderIf(props.fillQ && !props.inviteToCamp);
  const renderInviteToCamp = renderIf(props.inviteToCamp);

  return (

    <div className={cn('row', styles.container)}>
      <div className={cn('col s12', styles.listInBig)}>
        <div className={cn('col s5', styles.firstDiv)}>
          <div className={cn('col s2', styles.removePadding)}>
            <img className={styles.colgeIcon} src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png" alt="college-icon" />
          </div>
          <div className={cn('col s10', styles.textContainer)} >
            <span>
              {/* eslint-disable */}
              <div className={styles.collegeName}>
                <a href={props.saSchool.get('football_team_page')} target="_blank">
                  {props.saSchool.get('college')}
                </a>
              </div>
                {/* eslint-enable */}
              <div className={styles.lightText}>{props.saSchool.get('state')}</div>
            </span>
          </div>
        </div>
        <div className={cn('col s3', styles.equalDivs)}>
          <div className={cn('col s8', styles.textContainer)} >
            <span>
              <div className={styles.collegeName}>{props.saSchool.get('city')}</div>
              <div className={styles.lightText}>{props.saSchool.get('division')}</div>
            </span>
          </div>
        </div>
        <div className={cn('col s1', styles.lastDiv)} />
        <div className={cn('col s3', styles.equalDivs)}>
          <div className={styles.buttonContainer}>
            {renderIfIgnored(<span>
              {/* eslint-disable */}
                  {
                      props.inWishList ?
                          <a href="javascript:void(0)" title="Add to wishList" onClick={clickToRemoveFromWishList}>
                            <img className={styles.heartIcon} src="https://media.dev.myrecruitboard.com/Images/heart-full.png" alt="heartIcon" />
                          </a>
                          :
                          <a href="javascript:void(0)" title="Add to wishList" onClick={clickToAdd}>
                            <img className={styles.heartIcon} src="https://media.dev.myrecruitboard.com/Images/hearIcon.png" alt="heartIcon" />
                          </a>
                  }
                  {/* eslint-enable */}

              {
                      props.interested ? <button className={styles.interested}>
                        {renderDefaultStatus(
                                  'Awaiting Response',
                              )}
                        {renderFillQ(
                                  'Fill Questionaire',
                              )}
                        {renderInviteToCamp(
                                  'Invited to Camp',
                              )}
                      </button> :
                      <button className={styles.respond} onClick={clickToRequest}>
                        CONTACT COACH
                      </button>
                  }
            </span>)}

          </div>
        </div>
      </div>
      <div className={cn('col s12', styles.listInSmall)}>
        <div className={cn('col s3', styles.firstDiv)}>
          <img className={styles.colgeIcon} src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png" alt="college-icon" />
        </div>
        <div className={cn('col s9', styles.equalDivs)}>
          <div className={cn('col s12', styles.textContainer)} >
            <span>
              {/* eslint-disable */}
              <div className={styles.collegeName}>
                <a href={props.saSchool.get('football_team_page')} target="_blank">
                  {props.saSchool.get('college')}
                </a>
              </div>
                {/* eslint-enable */}
              <div className={styles.lightText}>{props.saSchool.get('state')}</div>
              <div className={styles.lightText}>{props.saSchool.get('city')}</div>
              <div className={styles.lightText}>{props.saSchool.get('division')}</div>
            </span>
          </div>
          {/* eslint-disable */}
          <span className={styles.absoluteHeart}>
            {
              props.inWishList ?
                <a href="javascript:void(0)" title="Add to wishList" onClick={clickToRemoveFromWishList}>
                  <img className={styles.heartIcon} src="https://media.dev.myrecruitboard.com/Images/heart-full.png" alt="heartIcon" />
                </a>
                  :
                <a href="javascript:void(0)" title="Add to wishList" onClick={clickToAdd}>
                  <img className={styles.heartIcon} src="https://media.dev.myrecruitboard.com/Images/hearIcon.png" alt="heartIcon" />
                </a>
          }
          </span>
            {/* eslint-disable */}
        </div>
        <div className={cn('col s12', styles.smallButtonContainer)}>
          <button onClick={clickToRequest}>
            CONTACT COACH
          </button>
        </div>
      </div>
    </div>

  );
};

SchoolListView.propTypes = {
  saSchool: PropTypes.shape().isRequired,
  inWishList: PropTypes.bool,
  inviteToCamp: PropTypes.bool,
  fillQ: PropTypes.bool,
  profileId: PropTypes.string.isRequired,
  fullname: PropTypes.string.isRequired,
  position_pref: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  sa_image: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
  addToList: PropTypes.func.isRequired,
  addToRequest: PropTypes.func.isRequired,
  interested: PropTypes.bool,
  wishListId: PropTypes.number,// eslint-disable-line
  removeFromList: PropTypes.func.isRequired, // eslint-disable-line
  ignoreListId: PropTypes.number,
  showSnackBar: PropTypes.func.isRequired,
  sa_email: PropTypes.string.isRequired,
  profile: PropTypes.shape().isRequired,
  showCounterScreen: PropTypes.func.isRequired,
  year_of_graduation: PropTypes.string.isRequired,
  weight: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  requestViewedCount: PropTypes.number.isRequired,
  t40: PropTypes.string.isRequired,
};

SchoolListView.defaultProps = {
  inWishList: false,
  interested: false,
  wishListId: -1,
  ignoreListId: -1,
  inviteToCamp: false,
  fillQ: false,
};


export default SchoolListView;



// WEBPACK FOOTER //
// ./src/components/SchoolListView/SchoolListView.js